// Product Fitment Banner - Custom Warning Banner
(function() {
  let fitmentLoadingUntil = 0;
  let fitmentLoadingTimeout = null;
  let apiCheckInProgress = false;
  let cachedApiFitmentResult = null; // Cache API result to avoid repeated calls

  // Keep this short so the banner doesn't feel stuck.
  // Automatically schedules a banner update after loading expires to prevent endless spinner.
  function setFitmentLoading(ms = 2500) {
    fitmentLoadingUntil = Date.now() + ms;

    // Clear any existing fallback timeout
    if (fitmentLoadingTimeout) {
      clearTimeout(fitmentLoadingTimeout);
    }

    // Schedule a banner update slightly after loading expires
    // This ensures the banner updates even if Convermax never responds (e.g., for unindexed SET products)
    fitmentLoadingTimeout = setTimeout(function() {
      if (!isFitmentLoading()) {
        createWarningBanner();
      }
    }, ms + 100);
  }

  function clearFitmentLoading() {
    fitmentLoadingUntil = 0;
    if (fitmentLoadingTimeout) {
      clearTimeout(fitmentLoadingTimeout);
      fitmentLoadingTimeout = null;
    }
  }

  function isFitmentLoading() {
    return Date.now() < fitmentLoadingUntil;
  }

  // Clear cached API result when vehicle changes
  function clearCachedApiFitment() {
    cachedApiFitmentResult = null;
  }

  // Fallback: Try Convermax verifyFitmentAsync API directly with product ID
  // This bypasses the variant ID lookup that fails for SET products
  async function tryVerifyFitmentAPI() {
    // Don't run multiple API checks simultaneously
    if (apiCheckInProgress) return;

    // Return cached result if available
    if (cachedApiFitmentResult !== null) {
      return cachedApiFitmentResult;
    }

    const vehicle = getStoredVehicle();
    if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) {
      return null;
    }

    // Check if Convermax API is available
    if (!window.Convermax || typeof window.Convermax.verifyFitmentAsync !== 'function') {
      return null;
    }

    // Get product ID - try Convermax Shopify helper first, then fallback to meta tag
    let productId = null;
    try {
      if (window.Convermax.Shopify && typeof window.Convermax.Shopify.getProductId === 'function') {
        productId = window.Convermax.Shopify.getProductId();
      }
    } catch (e) {
      // ignore
    }

    // Fallback: try to get product ID from Shopify meta or page data
    if (!productId) {
      try {
        const metaTag = document.querySelector('meta[name="product-id"]');
        if (metaTag) {
          productId = metaTag.getAttribute('content');
        }
      } catch (e) {
        // ignore
      }
    }

    // Another fallback: try ShopifyAnalytics
    if (!productId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      productId = window.ShopifyAnalytics.meta.product.id;
    }

    if (!productId) {
      return null;
    }

    apiCheckInProgress = true;

    try {
      const vehicleObj = {
        Year: String(vehicle.year),
        Make: String(vehicle.make),
        Model: String(vehicle.model)
      };

      const result = await window.Convermax.verifyFitmentAsync(String(productId), vehicleObj);

      // Map Convermax result to our status
      // Convermax returns: 'yes', 'no', 'unknown', or 'universal'
      if (result === 'yes' || result === 'universal') {
        cachedApiFitmentResult = 'fits';
      } else if (result === 'no') {
        cachedApiFitmentResult = 'does-not-fit';
      } else {
        cachedApiFitmentResult = 'unknown';
      }

      return cachedApiFitmentResult;
    } catch (e) {
      console.warn('[Fitment Banner] verifyFitmentAsync failed:', e);
      return null;
    } finally {
      apiCheckInProgress = false;
    }
  }

  function ensureLoaderStyles() {
    try {
      if (document.getElementById('fitment-banner-loader-style')) return;
      const style = document.createElement('style');
      style.id = 'fitment-banner-loader-style';
      style.textContent = `
        @keyframes fitmentSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .fitment-spinner { width: 16px; height: 16px; border-radius: 9999px; border: 2px solid currentColor; border-right-color: transparent; display: inline-block; vertical-align: -2px; margin-right: 8px; animation: fitmentSpin .8s linear infinite; }
        @keyframes fitmentDots { 0%, 20% { opacity: .15; } 50% { opacity: 1; } 100% { opacity: .15; } }
        .fitment-dots span { display:inline-block; margin-left:2px; animation: fitmentDots 1s infinite; }
        .fitment-dots span:nth-child(2) { animation-delay: .2s; }
        .fitment-dots span:nth-child(3) { animation-delay: .4s; }
      `;
      document.head.appendChild(style);
    } catch (e) {
      // ignore
    }
  }

  // Function to get stored vehicle
  function getStoredVehicle() {
    try {
      const vehicleData = sessionStorage.getItem('cm_vehicle');
      if (!vehicleData) return null;
      
      const vehicle = JSON.parse(vehicleData);
      return vehicle;
    } catch (e) {
      console.error('Error parsing vehicle data:', e);
      return null;
    }
  }

  function getVehicleFromConvermaxSources() {
    // 1) Convermax often stores the active YMM in localStorage under cm_variant-model
    try {
      const variantModel = localStorage.getItem('cm_variant-model');
      if (variantModel) {
        const modelData = JSON.parse(variantModel);
        if (Array.isArray(modelData) && modelData.length) {
          const vehicleData = {};
          modelData.forEach((item) => {
            if (!item) return;
            const field = (item.field || item.name || '').toString().toLowerCase();
            const value = (item.value || item.term || item.label || '').toString();
            if (!value) return;
            if (field === 'year') vehicleData.year = value;
            if (field === 'make') vehicleData.make = value;
            if (field === 'model') vehicleData.model = value;
          });

          if (vehicleData.year && vehicleData.make && vehicleData.model) {
            return vehicleData;
          }
        }
      }
    } catch (e) {
      // ignore
    }

    // 2) If Convermax exposes an API, use it
    try {
      if (window.Convermax && window.Convermax.api && typeof window.Convermax.api.getActiveVehicle === 'function') {
        const activeVehicle = window.Convermax.api.getActiveVehicle();
        if (activeVehicle && activeVehicle.year && activeVehicle.make && activeVehicle.model) {
          return {
            year: String(activeVehicle.year),
            make: String(activeVehicle.make),
            model: String(activeVehicle.model)
          };
        }
      }
    } catch (e) {
      // ignore
    }

    // 3) Last resort: read from the header/subheader Convermax widget selects in the DOM
    try {
      const allYear = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Year"]'));
      const allMake = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Make"]'));
      const allModel = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Model"]'));

      const yearSelect = allYear.find(el => !el.closest('#cm-verify-fitment')) || allYear[0];
      const makeSelect = allMake.find(el => !el.closest('#cm-verify-fitment')) || allMake[0];
      const modelSelect = allModel.find(el => !el.closest('#cm-verify-fitment')) || allModel[0];

      const year = yearSelect && yearSelect.value ? String(yearSelect.value).trim() : '';
      const make = makeSelect && makeSelect.value ? String(makeSelect.value).trim() : '';
      const model = modelSelect && modelSelect.value ? String(modelSelect.value).trim() : '';

      if (year && make && model) {
        return { year, make, model };
      }
    } catch (e) {
      // ignore
    }

    return null;
  }

  function ensureVehicleStored() {
    // localStorage ymm-year/make/model is the source of truth (Convermax's own sync script
    // writes to it on every vehicle change). If all three are set, honor it and sync the
    // sessionStorage cache. If ANY is missing, treat as "no vehicle selected" and clear the
    // cache — do NOT fall back to other Convermax sources, because those can retain stale
    // state from prior sessions and resurface phantom vehicles in the banner.
    try {
      const lsYear  = localStorage.getItem('ymm-year');
      const lsMake  = localStorage.getItem('ymm-make');
      const lsModel = localStorage.getItem('ymm-model');
      if (lsYear && lsMake && lsModel) {
        const v = { year: lsYear, make: lsMake, model: lsModel };
        try { sessionStorage.setItem('cm_vehicle', JSON.stringify(v)); } catch (e) {}
        return v;
      }
    } catch (e) {}

    // localStorage says no vehicle — clear the cache and report "no vehicle selected".
    try { sessionStorage.removeItem('cm_vehicle'); } catch (e) {}
    return null;
  }
  
  // Function to show modal
  function showVehicleModal() {
    // Remove existing modal if present
    const existingModal = document.getElementById('fitment-vehicle-modal');
    if (existingModal) {
      existingModal.remove();
    }

    // Open modal without clearing existing Convermax selection
    createModalAfterClear();
  }

  // Expose as a window global so other scripts (e.g. convermax-inject-scripts.js bridging
  // the theme's "open-filter-modal" custom event) can open the same vehicle modal that
  // the header fitment banner's "Enter your vehicle" link uses.
  window.showVehicleModal = showVehicleModal;
  
  // Function to create modal after clearing
  function createModalAfterClear() {
    
    // Create fresh modal
    const modal = document.createElement('div');
    modal.id = 'fitment-vehicle-modal';
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
    `;
    
    modal.innerHTML = `
      <div style="background: white; padding: 40px; border-radius: 0; max-width: 400px; width: 90%; position: relative; box-shadow: 0 4px 20px rgba(0,0,0,0.15);">
        <button id="close-modal-btn" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; cursor: pointer; color: #666; line-height: 1;">&times;</button>
        <h2 style="font-size: 18px; font-weight: 700; margin: 0 0 30px 0; color: #000; letter-spacing: 0.5px;">ENTER VEHICLE</h2>
        
        <select id="year-select" style="width: 100%; padding: 14px 16px; margin-bottom: 16px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; color: #000; background: white; appearance: none; background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg width=%2714%27 height=%278%27 viewBox=%270 0 14 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M1 1l6 6 6-6%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27/%3e%3c/svg%3e'); background-repeat: no-repeat; background-position: right 16px center; padding-right: 40px; cursor: pointer; line-height: 1.2; height: 52px;">
          <option value="">Year</option>
        </select>
        
        <select id="make-select" style="width: 100%; padding: 14px 16px; margin-bottom: 16px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; color: #000; background: white; appearance: none; background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg width=%2714%27 height=%278%27 viewBox=%270 0 14 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M1 1l6 6 6-6%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27/%3e%3c/svg%3e'); background-repeat: no-repeat; background-position: right 16px center; padding-right: 40px; cursor: pointer; line-height: 1.2; height: 52px;">
          <option value="">Make</option>
        </select>
        
        <select id="model-select" style="width: 100%; padding: 14px 16px; margin-bottom: 24px; border: 1px solid #ddd; border-radius: 4px; font-size: 16px; color: #000; background: white; appearance: none; background-image: url('data:image/svg+xml;charset=UTF-8,%3csvg width=%2714%27 height=%278%27 viewBox=%270 0 14 8%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M1 1l6 6 6-6%27 stroke=%27%23333%27 stroke-width=%272%27 stroke-linecap=%27round%27/%3e%3c/svg%3e'); background-repeat: no-repeat; background-position: right 16px center; padding-right: 40px; cursor: pointer; line-height: 1.2; height: 52px;">
          <option value="">Model</option>
        </select>
        
        <button id="vehicle-submit-btn" style="width: 100%; padding: 16px; background: #203772; color: white; border: none; border-radius: 4px; font-size: 16px; font-weight: 600; cursor: pointer; text-transform: capitalize;">Shop For This Vehicle</button>
      </div>
    `;
    
    document.body.appendChild(modal);
    
    // Prevent any redirects while modal is open
    const preventRedirect = (e) => {
      const target = e.target;
      if (target && target.classList && target.classList.contains('cm_vehicle-widget_button__go')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };
    
    // Prevent page navigation while modal is open
    const preventNavigation = (e) => {
      e.preventDefault();
      return false;
    };
    
    // Add global click interceptor
    document.addEventListener('click', preventRedirect, true);
    
    // Block beforeunload to prevent navigation
    window.addEventListener('beforeunload', preventNavigation, true);
    
    // Store cleanup function
    const cleanupModal = () => {
      document.removeEventListener('click', preventRedirect, true);
      window.removeEventListener('beforeunload', preventNavigation, true);
      modal.remove();
    };
    
    // Wait for modal to be in DOM, then populate from Convermax
    setTimeout(() => {
      // Get Convermax selects: prefer verify-fitment widget, but fall back to global widget if needed
      let cmYearSelect = null;
      let cmMakeSelect = null;
      let cmModelSelect = null;

      const fitmentRoot = document.querySelector('#cm-verify-fitment');
      if (fitmentRoot) {
        cmYearSelect = fitmentRoot.querySelector('.cm_select_inner-select[aria-label="Year"]');
        cmMakeSelect = fitmentRoot.querySelector('.cm_select_inner-select[aria-label="Make"]');
        cmModelSelect = fitmentRoot.querySelector('.cm_select_inner-select[aria-label="Model"]');
      }

      // If verify-fitment selects are not available or not populated, fall back to the main Convermax widget
      const needsFallback = !cmYearSelect || (cmYearSelect && cmYearSelect.options && cmYearSelect.options.length <= 1);
      if (needsFallback) {
        cmYearSelect = document.querySelector('.cm_select_inner-select[aria-label="Year"]');
        cmMakeSelect = document.querySelector('.cm_select_inner-select[aria-label="Make"]');
        cmModelSelect = document.querySelector('.cm_select_inner-select[aria-label="Model"]');
      }
      
      // Get modal selects
      const modalYearSelect = modal.querySelector('#year-select');
      const modalMakeSelect = modal.querySelector('#make-select');
      const modalModelSelect = modal.querySelector('#model-select');
      const submitBtn = modal.querySelector('#vehicle-submit-btn');
      
      
      // Copy options from Convermax to modal
      if (cmYearSelect && modalYearSelect) {
        // Clone all options from Convermax year select
        const yearOptions = Array.from(cmYearSelect.options);
        modalYearSelect.innerHTML = '';
        yearOptions.forEach(option => {
          const newOption = document.createElement('option');
          newOption.value = option.value;
          newOption.textContent = option.textContent.trim();
          modalYearSelect.appendChild(newOption);
        });
      }
      
      // Year change handler - populate Make options by syncing with Convermax (already cleared)
      if (modalYearSelect && cmYearSelect) {
        modalYearSelect.addEventListener('change', function() {
          
          cmYearSelect.value = this.value;
          cmYearSelect.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Wait for Make options to load
          setTimeout(() => {
            if (cmMakeSelect && modalMakeSelect) {
              const makeOptions = Array.from(cmMakeSelect.options);
              
              if (makeOptions.length > 1) {
                modalMakeSelect.innerHTML = '';
                makeOptions.forEach(option => {
                  const newOption = document.createElement('option');
                  newOption.value = option.value;
                  newOption.textContent = option.textContent.trim();
                  if (option.disabled) newOption.disabled = true;
                  modalMakeSelect.appendChild(newOption);
                });
                modalMakeSelect.disabled = false;
              }
            }
          }, 500);
        });
      }
      
      // Make change handler - populate Model options
      if (modalMakeSelect && cmMakeSelect) {
        modalMakeSelect.addEventListener('change', function() {
          
          cmMakeSelect.value = this.value;
          cmMakeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Wait for Model options to load
          setTimeout(() => {
            if (cmModelSelect && modalModelSelect) {
              const modelOptions = Array.from(cmModelSelect.options);
              
              if (modelOptions.length > 1) {
                modalModelSelect.innerHTML = '';
                modelOptions.forEach(option => {
                  const newOption = document.createElement('option');
                  newOption.value = option.value;
                  newOption.textContent = option.textContent.trim();
                  if (option.disabled) newOption.disabled = true;
                  modalModelSelect.appendChild(newOption);
                });
                modalModelSelect.disabled = false;
              }
            }
          }, 500);
        });
      }
      
      // Submit button - save and update banner without reload
      if (submitBtn) {
        submitBtn.addEventListener('click', function() {
          
          const selectedYear = modalYearSelect.value;
          const selectedMake = modalMakeSelect.value;
          const selectedModel = modalModelSelect.value;
          
          
          if (!selectedYear || !selectedMake || !selectedModel) {
            return;
          }
          
          // Save to sessionStorage
          const vehicleData = {
            year: selectedYear,
            make: selectedMake,
            model: selectedModel
          };
          sessionStorage.setItem('cm_vehicle', JSON.stringify(vehicleData));
          clearCachedApiFitment(); // Clear cache when vehicle changes

          // Also write to the localStorage keys that are the gate's source of truth and
          // fire the events that product-form.js + this banner listen to. Without these,
          // the Add-to-Cart gate and the refreshed top banner can't see the new vehicle
          // because they ignore sessionStorage.cm_vehicle in favor of localStorage ymm-*.
          try {
            localStorage.setItem('ymm-year', selectedYear);
            localStorage.setItem('ymm-make', selectedMake);
            localStorage.setItem('ymm-model', selectedModel);
          } catch (e) {}
          window.dispatchEvent(new CustomEvent('ymmUpdated', { detail: { year: selectedYear, make: selectedMake, model: selectedModel } }));
          window.dispatchEvent(new CustomEvent('fitment:refresh'));

          // Update the global header Shop By Vehicle widget so its dropdowns visually
          // reflect the selection the customer made in the modal. Targets .cm_vehicle-widget
          // dropdowns specifically NOT inside #cm-verify-fitment (that widget gets handled
          // separately below).
          try {
            const hdrYear  = Array.from(document.querySelectorAll('.cm_vehicle-widget .cm_select_inner-select[aria-label="Year"]')).find(el => !el.closest('#cm-verify-fitment'));
            const hdrMake  = Array.from(document.querySelectorAll('.cm_vehicle-widget .cm_select_inner-select[aria-label="Make"]')).find(el => !el.closest('#cm-verify-fitment'));
            const hdrModel = Array.from(document.querySelectorAll('.cm_vehicle-widget .cm_select_inner-select[aria-label="Model"]')).find(el => !el.closest('#cm-verify-fitment'));
            if (hdrYear && hdrMake && hdrModel) {
              hdrYear.value = selectedYear;
              hdrYear.dispatchEvent(new Event('change', { bubbles: true }));
              // Stagger cascade: Convermax repopulates Make options when Year changes, and
              // Model options when Make changes. Match the 600ms cadence used by the existing
              // #cm-verify-fitment sync below.
              setTimeout(() => {
                hdrMake.value = selectedMake;
                hdrMake.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(() => {
                  hdrModel.value = selectedModel;
                  hdrModel.dispatchEvent(new Event('change', { bubbles: true }));
                }, 600);
              }, 600);
            }
          } catch (e) {}

          // Show loading state immediately while Convermax checks fitment
          setFitmentLoading(2500);
          createWarningBanner();

          // Remove redirect prevention and close modal
          document.removeEventListener('click', preventRedirect, true);
          window.removeEventListener('beforeunload', preventNavigation, true);
          modal.remove();
          
          // Set the Convermax verify fitment selects with proper cascade and trigger check
          setTimeout(() => {
            const cmVerifyYear = document.querySelector('#cm-verify-fitment .cm_select_inner-select[aria-label="Year"]');
            const cmVerifyMake = document.querySelector('#cm-verify-fitment .cm_select_inner-select[aria-label="Make"]');
            const cmVerifyModel = document.querySelector('#cm-verify-fitment .cm_select_inner-select[aria-label="Model"]');
            const cmVerifyGoButton = document.querySelector('#cm-verify-fitment .cm_vehicle-widget_button__go');
            
            if (cmVerifyYear && cmVerifyMake && cmVerifyModel && cmVerifyGoButton) {
              cmVerifyYear.value = selectedYear;
              cmVerifyYear.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Wait for Make options to populate
              setTimeout(() => {
                cmVerifyMake.value = selectedMake;
                cmVerifyMake.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Wait for Model options to populate
                setTimeout(() => {
                  cmVerifyModel.value = selectedModel;
                  cmVerifyModel.dispatchEvent(new Event('change', { bubbles: true }));
                  
                  // Now click the verify fitment GO button
                  setTimeout(() => {
                    cmVerifyGoButton.removeAttribute('disabled');
                    cmVerifyGoButton.setAttribute('tabindex', '0');
                    
                    cmVerifyGoButton.click();

                    // After Convermax processes the new selection, refresh the banner
                    setTimeout(() => {
                      createWarningBanner();
                    }, 1500);
                  }, 300);
                }, 600);
              }, 600);
            }
          }, 200);
        });
      }
    }, 300);
    
    // Close button handler
    const closeBtn = modal.querySelector('#close-modal-btn');
    closeBtn.addEventListener('click', function() {
      cleanupModal();
    });
    
    // Close on background click
    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        cleanupModal();
      }
    });
  }
  
  // Function to create the warning banner
  // #424 — Accessory products have no fitment data; hide the fitment ribbon for them.
  // Matches the product's oew.shopify_product_classifier metafield (exposed by the product
  // section as window.OEW_PRODUCT_CLASSIFIER). Normalized compare handles case/spacing and
  // singular/plural ("T-Shirt"/"T-Shirts", "Hub Ring"/"Hub Rings"). Single/Set/Kit-package
  // are intentionally NOT in the list, so fitment keeps working for them.
  function isFitmentSuppressedClassifier() {
    try {
      var raw = window.OEW_PRODUCT_CLASSIFIER;
      if (!raw) return false;
      var norm = String(raw).toLowerCase().replace(/[^a-z0-9]/g, '');
      var SUPPRESS = ['tpms','lugs','lug','hubrings','hubring','caps','cap','tshirt','tshirts','hats','hat','hoodies','hoodie'];
      return SUPPRESS.indexOf(norm) !== -1;
    } catch (e) { return false; }
  }

  function createWarningBanner() {
    // Check if we're on a product page
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    // #424 — Suppress the fitment ribbon entirely for accessory classifiers.
    if (isFitmentSuppressedClassifier()) {
      var suppressed = document.getElementById('product-fitment-top-banner');
      if (suppressed) suppressed.remove();
      return;
    }

    const vehicleForBanner = ensureVehicleStored();
    
    // Remove existing banner if present
    let existingBanner = document.getElementById('product-fitment-top-banner');
    if (existingBanner) {
      existingBanner.remove();
    }
    
    // Create banner wrapper
    const banner = document.createElement('div');
    banner.id = 'product-fitment-top-banner';
    banner.style.cssText = `
      width: 100%;
      padding: 12px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      margin: 0 0 20px 0;
      box-sizing: border-box;
    `;
    
    if (vehicleForBanner && vehicleForBanner.year && vehicleForBanner.make && vehicleForBanner.model) {
      const vehicleName = `${vehicleForBanner.year} ${vehicleForBanner.make} ${vehicleForBanner.model}`;

      // Check if product fits this vehicle (DOM-based check first)
      let fitmentStatus = checkProductFitment();

      // If DOM check returned 'unknown', check if we have a cached API result
      if (fitmentStatus === 'unknown' && cachedApiFitmentResult !== null) {
        fitmentStatus = cachedApiFitmentResult;
      }

      // As soon as Convermax reports a definitive result, exit loading.
      if (fitmentStatus === 'fits' || fitmentStatus === 'does-not-fit') {
        clearFitmentLoading();
      }

      // If still unknown and not currently loading, trigger API fallback check
      // This handles SET products where the widget doesn't populate
      if (fitmentStatus === 'unknown' && !isFitmentLoading() && !apiCheckInProgress && cachedApiFitmentResult === null) {
        // Trigger async API check - will update banner when done
        tryVerifyFitmentAPI().then(function(apiResult) {
          if (apiResult && apiResult !== 'unknown') {
            // API returned a definitive result, refresh banner
            createWarningBanner();
          }
        }).catch(function() {
          // Ignore errors, banner already shows 'unknown'
        });
      }
      
      if (fitmentStatus === 'does-not-fit') {
        // Red banner - Product DOES NOT fit
        banner.style.background = '#FFE5E5';
        banner.innerHTML = `
          <span style="color: #203772; font-size: 18px; font-weight: 700; flex-shrink: 0;">⚠️</span>
          <span style="color: #7F1D1D; font-size: 16px; font-weight: 400;">
            This product <strong style="font-weight: 700;">DOES NOT</strong> fit your <strong style="font-weight: 700; text-transform: uppercase;">${vehicleName}</strong>
            <a href="#" class="change-vehicle-link" style="color: #7F1D1D; text-decoration: underline; margin-left: 8px;  cursor: pointer;">change vehicle</a>
            <a href="#" class="shop-wheels-fit-link" style="color: #7F1D1D; text-decoration: underline; margin-left: 8px;  cursor: pointer;">shop wheels that fit</a>
          </span>
        `;
      } else if (fitmentStatus === 'fits') {
        // Green banner - Product FITS
        banner.style.background = '#E1FFED';
        banner.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
            <circle cx="12" cy="12" r="10" fill="#00C853"/>
            <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span style="color: #004D1A; font-size: 16px; font-weight: 400;">
            This product fits your <strong style="font-weight: 700; text-transform: uppercase;">${vehicleName}</strong>
            <a href="#" class="change-vehicle-link" style="color: #004D1A; text-decoration: underline; margin-left: 8px;  cursor: pointer;">change vehicle</a>
          </span>
        `;
      } else {
        // Yellow banner - loading/unavailable
        ensureLoaderStyles();
        banner.style.background = '#FFF4E5';

        const loading = isFitmentLoading();
        banner.innerHTML = `
          <span style="color: #FF9800; font-size: 18px; font-weight: 700; flex-shrink: 0;">⚠️</span>
          <span style="color: #663C00; font-size: 16px; font-weight: 400;">
            ${loading ? `<span class=\"fitment-spinner\" aria-hidden=\"true\"></span>Checking fitment for <strong style=\"font-weight: 700; text-transform: uppercase;\">${vehicleName}</strong> <span class=\"fitment-dots\" aria-hidden=\"true\"><span>.</span><span>.</span><span>.</span></span>` : `Fitment status unavailable for <strong style=\"font-weight: 700; text-transform: uppercase;\">${vehicleName}</strong>`}
            <a href="#" class="change-vehicle-link" style="color: #663C00; text-decoration: underline; margin-left: 8px; cursor: pointer;">change vehicle</a>
          </span>
        `;
      }
      
      // Add click handler for change vehicle link and "Shop wheels that fit" link
      setTimeout(() => {
        const changeLink = banner.querySelector('.change-vehicle-link');
        const shopWheelsBtn = banner.querySelector('.shop-wheels-fit-link');
        if (changeLink) {
          changeLink.addEventListener('click', function(e) {
            e.preventDefault();
            // When changing vehicle, first trigger Convermax CLEAR to reset state
            const cmClearButton = document.querySelector('.cm_vehicle-widget_button__clear');
            if (cmClearButton) {
              cmClearButton.click();
              // Give Convermax a moment to clear before opening modal
              setTimeout(() => {
                showVehicleModal();
              }, 300);
            } else {
              showVehicleModal();
            }
          });
        }

        if (shopWheelsBtn) {
          shopWheelsBtn.addEventListener('click', function(e) {
            e.preventDefault();

            if (!vehicleForBanner || !vehicleForBanner.year || !vehicleForBanner.make || !vehicleForBanner.model) {
              return;
            }

            // Find Convermax global (search) widget selects and GO button (exclude verify-fitment container)
            const allYear = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Year"]'));
            const allMake = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Make"]'));
            const allModel = Array.from(document.querySelectorAll('.cm_select_inner-select[aria-label="Model"]'));
            const allGoButtons = Array.from(document.querySelectorAll('.cm_vehicle-widget_button__go'));

            const yearSelect = allYear.find(el => !el.closest('#cm-verify-fitment')) || allYear[0];
            const makeSelect = allMake.find(el => !el.closest('#cm-verify-fitment')) || allMake[0];
            const modelSelect = allModel.find(el => !el.closest('#cm-verify-fitment')) || allModel[0];
            const goButton = allGoButtons.find(el => !el.closest('#cm-verify-fitment')) || allGoButtons[0];

            if (!yearSelect || !makeSelect || !modelSelect || !goButton) {
              return;
            }


            // Set Y/M/M on the global widget and then trigger GO (allowing redirect to search page)
            yearSelect.value = vehicleForBanner.year;
            yearSelect.dispatchEvent(new Event('change', { bubbles: true }));

            setTimeout(() => {
              makeSelect.value = vehicleForBanner.make;
              makeSelect.dispatchEvent(new Event('change', { bubbles: true }));

              setTimeout(() => {
                modelSelect.value = vehicleForBanner.model;
                modelSelect.dispatchEvent(new Event('change', { bubbles: true }));

                setTimeout(() => {
                  goButton.removeAttribute('disabled');
                  goButton.setAttribute('tabindex', '0');
                  goButton.click();
                }, 300);
              }, 600);
            }, 600);
          });
        }
      }, 100);
    } else {
      // Yellow warning - No vehicle selected
      banner.style.background = '#FFF4E5';
      banner.innerHTML = `
        <span style="color: #FF9800; font-size: 18px; font-weight: 700; flex-shrink: 0;">⚠️</span>
        <span style="color: #663C00; font-size: 16px; font-weight: 400;">
          <a href="#" class="fitment-banner-link" style="color: #663C00; text-decoration: underline; font-weight: 600; cursor: pointer;">Enter your vehicle</a> to ensure this product will fit
        </span>
      `;
      
      // Add click handler to show modal
      setTimeout(() => {
        const link = banner.querySelector('.fitment-banner-link');
        if (link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            showVehicleModal();
          });
        }
      }, 100);
    }
    
    // Fill the slot main-product-page.liquid reserves for the ribbon, so the product doesn't
    // jump down when it appears (CLS); otherwise insert before shopify-section-main-product
    const bannerSlot = document.getElementById('fitment-banner-slot');
    const productSection = document.querySelector('.shopify-section-main-product');
    if (bannerSlot) {
      bannerSlot.appendChild(banner);
    } else if (productSection) {
      productSection.parentNode.insertBefore(banner, productSection);
    } else {
      // Fallback: insert at top of main content
      const mainContent = document.getElementById('main-content') || document.querySelector('main');
      if (mainContent) {
        mainContent.insertBefore(banner, mainContent.firstChild);
      }
    }
    
    // Also hide the cm-verify-fitment container since we're showing banner at top
    const cmContainer = document.getElementById('cm-verify-fitment');
    if (cmContainer) {
      cmContainer.style.display = 'none';
    }
    
  }
  
  // Function to check product fitment status
  function checkProductFitment() {
    // Check Convermax fitment indicator on the page
    const fitmentContainer = document.querySelector('#cm-verify-fitment');
    if (!fitmentContainer) {
      return 'unknown';
    }

    // Some Convermax installs report fitment via container classes.
    // Prefer these first because they can be faster/more reliable.
    const containerClassList = fitmentContainer.classList;
    if (containerClassList) {
      if (containerClassList.contains('cm-fit-nomatch') || containerClassList.contains('cm-fit-no-match')) {
        return 'does-not-fit';
      }
      if (containerClassList.contains('cm-fit-match')) {
        return 'fits';
      }
      // cm-fit-specific typically means "needs exact trim" or a non-binary state.
    }
    
    
    // Check for Convermax's specific "no fit" class
    const noFitElement = fitmentContainer.querySelector('.cm_verify-fitment__no');
    if (noFitElement) {
      return 'does-not-fit';
    }
    
    // Also check for "yes fit" class to be explicit
    const yesFitElement = fitmentContainer.querySelector('.cm_verify-fitment__yes');
    if (yesFitElement) {
      return 'fits';
    }
    
    // Check text content for "DOES NOT Fit"
    const allText = fitmentContainer.textContent || '';
    if (allText.includes('DOES NOT Fit') || allText.includes('does not fit')) {
      return 'does-not-fit';
    }

    // Some variants use a short "Fits" message without the yes element.
    // Guard against false positives by requiring the word to stand alone.
    if (/\bfits\b/i.test(allText) && !/does\s+not\s+fit/i.test(allText)) {
      return 'fits';
    }

    // If we have no explicit yes/no signal yet, treat as unknown
    return 'unknown';
  }
  
  // Initialize
  function init() {
    // Check if we're on a product page
    if (!document.body.classList.contains('template-product')) {
      return;
    }
    
    // Wait for Convermax to load and update fitment before creating initial banner
    const waitForConvermax = () => {
      let attempts = 0;
      const maxAttempts = 30;
      
      const checkConvermax = () => {
        attempts++;
        
        const fitmentContainer = document.querySelector('#cm-verify-fitment');
        if (fitmentContainer) {
          const hasNoFit = fitmentContainer.querySelector('.cm_verify-fitment__no') || fitmentContainer.classList.contains('cm-fit-nomatch') || fitmentContainer.classList.contains('cm-fit-no-match');
          const hasYesFit = fitmentContainer.querySelector('.cm_verify-fitment__yes') || fitmentContainer.classList.contains('cm-fit-match');
          
          
          // If Convermax has loaded with fitment status, create banner
          if (hasNoFit || hasYesFit) {
            createWarningBanner();
            return;
          }
        }
        
        // If we haven't found fitment status yet, keep checking
        if (attempts < maxAttempts) {
          setTimeout(checkConvermax, 200);
        } else {
          createWarningBanner();
        }
      };
      
      // Start checking after page load
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(checkConvermax, 500);
        });
      } else {
        setTimeout(checkConvermax, 500);
      }
    };
    
    // Reconcile sessionStorage.cm_vehicle against localStorage ymm-year/make/model on boot.
    // Convermax's sync script writes current vehicle state to those localStorage keys in a
    // 1s setInterval, so localStorage is effectively the source of truth. The sessionStorage
    // cache can end up stale (e.g. if the customer cleared YMM on the previous page, or if
    // page load happened faster than the Convermax sync could run). Without this boot-time
    // reconciliation, the top "This product fits your …" banner can show a phantom vehicle
    // while the YMM bar and inner PDP correctly show "no vehicle selected".
    try {
      const lsYear  = localStorage.getItem('ymm-year');
      const lsMake  = localStorage.getItem('ymm-make');
      const lsModel = localStorage.getItem('ymm-model');
      if (lsYear && lsMake && lsModel) {
        sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: lsYear, make: lsMake, model: lsModel }));
      } else {
        sessionStorage.removeItem('cm_vehicle');
      }
    } catch (e) {}

    // If the user arrives from Convermax search via header/subheader selector,
    // the active vehicle is usually in localStorage (cm_variant-model).
    // Pull it into sessionStorage so our product banner can display it.
    ensureVehicleStored();

    waitForConvermax();

    // Watch Convermax fitment widget for changes so we can resolve loading quickly.
    const attachFitmentObserver = () => {
      const fitmentContainer = document.querySelector('#cm-verify-fitment');
      if (!fitmentContainer || fitmentContainer.__fitmentBannerObserved) return;

      fitmentContainer.__fitmentBannerObserved = true;
      let rafScheduled = false;
      const scheduleUpdate = () => {
        if (rafScheduled) return;
        rafScheduled = true;
        requestAnimationFrame(() => {
          rafScheduled = false;
          createWarningBanner();
        });
      };

      try {
        const mo = new MutationObserver(() => {
          scheduleUpdate();
        });
        mo.observe(fitmentContainer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      } catch (e) {
        // ignore
      }
    };

    // Try immediately and also retry briefly (Convermax often injects late).
    attachFitmentObserver();
    let obsAttempts = 0;
    const obsTimer = setInterval(() => {
      obsAttempts++;
      attachFitmentObserver();
      if (obsAttempts >= 20) clearInterval(obsTimer);
    }, 250);
    
    // Update banner when vehicle changes
    document.addEventListener('click', function(e) {
      const goBtn = e.target.closest('.cm_vehicle-widget_button__go');
      const clearBtn = e.target.closest('.cm_vehicle-widget_button__clear');

      if (goBtn || clearBtn) {
        if (goBtn) {
          // Capture whatever vehicle Convermax currently has selected.
          ensureVehicleStored();
          // Any GO click means Convermax is about to re-check fitment.
          setFitmentLoading(2500);
          // Update banner immediately to show the loading state.
          setTimeout(createWarningBanner, 0);
        }

        // If Convermax CLEAR is clicked, also clear our stored vehicle
        if (clearBtn) {
          try {
            sessionStorage.removeItem('cm_vehicle');
            clearCachedApiFitment(); // Clear cache when vehicle is cleared
          } catch (err) {
            console.error('Error clearing stored vehicle on CLEAR:', err);
          }
        }

        setTimeout(createWarningBanner, 300);
      }
    });
    
    // Listen for storage changes
    window.addEventListener('storage', function(e) {
      if (e.key === 'cm_vehicle' || e.key === null) {
        createWarningBanner();
      }
    });

    // Re-render the banner when the gate reports a YMM update or fitment refresh.
    // These events are fired by convermax-inject-scripts.js's PDP navigation interceptor
    // (when the customer changes vehicle via the header Shop By Vehicle bar) and by ymm.js
    // whenever fitment needs to be re-evaluated. Without this, the top banner can get stuck
    // showing a stale vehicle/fitment message.
    const refreshBannerOnYmm = function(e) {
      // The banner caches the active vehicle in sessionStorage.cm_vehicle and reuses it
      // across re-renders, so simply re-rendering isn't enough when the customer switched
      // vehicles. Overwrite the cache from the event detail (preferred) or from localStorage
      // so the banner recomputes against the current YMM.
      const detail = (e && e.detail) || {};
      const year  = detail.year  || localStorage.getItem('ymm-year');
      const make  = detail.make  || localStorage.getItem('ymm-make');
      const model = detail.model || localStorage.getItem('ymm-model');
      try {
        if (year && make && model) {
          sessionStorage.setItem('cm_vehicle', JSON.stringify({ year: String(year), make: String(make), model: String(model) }));
        } else {
          sessionStorage.removeItem('cm_vehicle');
        }
      } catch (err) {}
      clearCachedApiFitment();
      setFitmentLoading(2500);
      setTimeout(createWarningBanner, 0);
      setTimeout(createWarningBanner, 600);
    };
    window.addEventListener('ymmUpdated', refreshBannerOnYmm);
    window.addEventListener('fitment:refresh', refreshBannerOnYmm);
    
    // Check periodically if banner was removed
    setInterval(function() {
      const existingBanner = document.getElementById('product-fitment-top-banner');
      if (!existingBanner && document.body.classList.contains('template-product')) {
        createWarningBanner();
      }
    }, 2000);
  }
  
  init();
})();
